import { readSecureCheckoutState } from "@/lib/checkout-state";

export function isPrivateCheckoutEntry(search: string, ownerId?: string): boolean {
  const params = new URLSearchParams(search);
  const state = readSecureCheckoutState(params.get("h") || "", ownerId, true);
  return ["quote", "winback", "probe", "resume", "publicId"].some(key => params.has(key)) ||
    !!(state.quoteToken || state.winBackToken || state.probeToken || state.checkoutSessionPublicId);
}

export function canRecoverInlineCheckout(pathname: string, search: string, ownerId?: string): boolean {
  const base = import.meta.env.BASE_URL || "/";
  const path = base !== "/" && pathname.startsWith(base) ? `/${pathname.slice(base.length)}` : pathname;
  return /^\/(?:[a-z]{2}\/){0,2}checkout\/?$/i.test(path) && !isPrivateCheckoutEntry(search, ownerId);
}
